<template>
  <div class="pt-2 pb-3">
  <h3 class="px-3 text-xs uppercase font-bold tracking-wide">{{ filter.name }}</h3>

    <div class="mt-1 px-3">
        <date-time-picker
            class="w-full block form-control form-select form-control-sm form-select-bordered"
            dusk="date-filter"
            name="date-filter"
            autocomplete="off"
            :value="value"
            alt-format="Y-m-d"
            date-format="Y-m-d"
            :placeholder="placeholder"
            :enable-time="false"
            :enable-seconds="false"
            :first-day-of-week="firstDayOfWeek"
            @input.prevent=""
            @change="handleChange"
        />
    </div>
  </div>
</template>

<script>
import DateTimePicker from "../../globals/DateTimePicker";
export default {
  emits: ['change'],
    components: {
      'date-time-picker': DateTimePicker
    },
  props: {
    resourceName: {
      type: String,
      required: true,
    },
    filterKey: {
      type: String,
      required: true,
    },
    lens: String,
  },

  methods: {
    handleChange(event) {
      let value = event?.target?.value ?? event

      this.$store.commit(`${this.resourceName}/updateFilterState`, {
        filterClass: this.filterKey,
        value,
      })

      this.$emit('change')
    },
  },

  computed: {
    placeholder() {
      return this.filter.placeholder || this.__('Choose date')
    },

    value() {
      return this.filter.currentValue
    },

    filter() {
      return this.$store.getters[`${this.resourceName}/getFilter`](
        this.filterKey
      )
    },

    options() {
      return this.$store.getters[`${this.resourceName}/getOptionsForFilter`](
        this.filterKey
      )
    },

      firstDayOfWeek() {
          return this.filter.firstDayOfWeek || 0
      },
  },
}
</script>
